import React, { useContext } from "react";
import { mainContext } from "reducer";

const LangToggle = () => {
  const { dispatch, state } = useContext(mainContext);
  const { locale } = state;

  const changeLang = (e, lang) => {
    dispatch({
      type: "CHANGE_LOCALE",
      locale: lang,
    });
  };

  return (
    <>
      <button
        className="text-grey-add4 rounded w-40-px h-40-px focus:outline-none hover-opacity-1"
        onClick={(e) => {
          changeLang(e, locale === "zh" ? "en" : "zh");
        }}
      >
        <div className="p-2 font-bold">{locale === "zh" ? "EN" : "CN"}</div>
      </button>
    </>
  );
};

export default LangToggle;
